import React from 'react';
import I18n from 'i18n-js';
import {
  MParticleEventName,
  MParticlePageName,
  trackEvent,
} from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import CmsListingsCollection, { ADDITIONAL_SORTS } from '@reverbdotcom/commons/src/cms/components/cms_listings_collection';

interface ExternalProps {
  listing: any;
  pageName: MParticlePageName;
}

export default function Item2PromotedSimilarListingsRow({ listing, pageName }: ExternalProps) {
  const COMPONENT_NAME = 'Item2PromotedSimilarListings';

  if (!listing) return null;

  trackEvent({
    eventName: MParticleEventName.ComponentView,
    listing: listing,
    componentName: COMPONENT_NAME,
    pageName: pageName,
  });

  return (
    <CmsListingsCollection
      componentName={COMPONENT_NAME}
      sort={ADDITIONAL_SORTS.BUMP_BOOST}
      title={I18n.t('discovery.itemShow.promotedSimilarListings')}
      similarListingIds={[listing.id]}
      maxCount={12}
      largeTiles
      ssr={false}
    />
  );
}
